import moment from 'moment';
import { storeLocalData, getLocalData, clearLocalData } from './storage';

const sleep = (delay: number) => new Promise((resolve) => setTimeout(resolve, delay));

const openHouses = [];
const forms = [];


export const setOpenHouse = async (openHouse) => {
  openHouses.push(openHouse);
  await storeLocalData('openHouses', JSON.stringify(openHouses));
};

export const getOpenHouses = async () => {
  const data = await getLocalData('openHouses'); 
  const parsedData = data ? JSON.parse(data) : [];

  const upcoming = parsedData?.filter((item) => {
    const date = moment(item?.date, 'MM/DD/YYYY');

    const today = moment();
    const diffTime = date.diff(today, 'days');

    return diffTime >= 0;
  });

  const past = parsedData?.filter((item) => {
    const date = moment(item?.date, 'MM/DD/YYYY');

    const today = moment();
    const diffTime = date.diff(today, 'days');

    return diffTime < 0;
  });

  return { upcoming, past };
};

//add open house
export const addOpenHouse = async (openHouse) => {
  const data = await getLocalData('openHouses');
  const openHouses = data ? JSON.parse(data) : [];
  openHouse.id = openHouses?.length + 1;
  openHouse.status = 'NotStarted';
  openHouse.attendees = [];
  //openHouse.formId = openHouse.formId.value
  openHouses.push(openHouse);
  await storeLocalData('openHouses', JSON.stringify(openHouses));
  return openHouse;
};

// clear open houses
export const clearOpenHouses = async () => {
  await clearLocalData('openHouses');
};

// delete open house
export const deleteOpenHouseById = async (id) => {
  const data = await getLocalData('openHouses');
  const openHouses = data ? JSON.parse(data) : [];
  const newOpenHouses = openHouses.filter((openHouse) => openHouse?.id !== id);
  await storeLocalData('openHouses', JSON.stringify(newOpenHouses));
};

//get open house by id
export const getOpenHouseById = async (id) => {
  //await sleep(1000);
  const data = await getLocalData('openHouses');
  const openHouses = data ? JSON.parse(data) : [];
  return openHouses.find((openHouse) => openHouse?.id === id);
};

//update open house
export const updateOpenHouseById = async (id, openHouse) => { 

  const data = await getLocalData('openHouses');
  const openHouses = data ? JSON.parse(data) : [];

  const index = openHouses.findIndex((openHouse) => openHouse?.id === id);
  openHouses[index] = openHouse;
  await storeLocalData('openHouses', JSON.stringify(openHouses));
  return openHouse;
};

// add attendee to open house
export const addAttendeeToOpenHouse = async (id, attendee) => { 

  const data = await getLocalData('openHouses');
  const openHouses = data ? JSON.parse(data) : [];
  const index = openHouses.findIndex((openHouse) => openHouse.id === id);

  openHouses[index].attendees.push(attendee);

  await storeLocalData('openHouses', JSON.stringify(openHouses));
  return openHouses[index];
};

export const clearForms = async () => {
  await clearLocalData('forms');
}

export const addForm = async (form) => {
  const data = await getLocalData('forms');
  const forms = data ? JSON.parse(data) : [];
  form.id = forms?.length + 1;
  forms.push(form);
  await storeLocalData('forms', JSON.stringify(forms));
  return form;
}

export const getForms = async () => {
  const data = await getLocalData('forms');
  const forms = data ? JSON.parse(data) : [];
  return forms;
}

export const getFormById = async (id) => {
  const data = await getLocalData('forms');
  const forms = data ? JSON.parse(data) : [];
  return forms.find((form) => form?.id === id);
}

export const updateFormById = async (id, form) => {
  const data = await getLocalData('forms');
  const forms = data ? JSON.parse(data) : [];
  const index = forms.findIndex((form) => form?.id === id);
  forms[index] = form;
  await storeLocalData('forms', JSON.stringify(forms));
  return form;
}

export const deleteFormById = async (id) => {

  const data = await getLocalData('forms');
  const forms = data ? JSON.parse(data) : [];
  const newForms = forms.filter((form) => form?.id !== id);
  await storeLocalData('forms', JSON.stringify(newForms));
}


